import { Injectable, OnDestroy, Pipe, PipeTransform, signal, untracked, } from '@angular/core';
import { FormattingUtility } from "@utilities/formatting.utility";

@Pipe({
	name: 'FriendlyBytes',
	standalone: true,
	pure: false,
})
@Injectable({
	providedIn: 'root',
})
export class FriendlyBytesPipe implements PipeTransform, OnDestroy {
	private prevValue: string | null = null;
	private state = signal<string | null>(null);
	private intervalId: any;

	private startTimer(value: string): void {
		// Start the timer to update the signal every second
		this.intervalId = setInterval(() => {
			this.state.set(FormattingUtility.bytesAsFriendly((value as any) * Math.pow(1024, 2)));
		}, 1000);
	}

	transform(value: string): string | null {
		// On the first transform or when the value changes, initialize the state and start the timer
		if (this.prevValue !== value) {
			this.prevValue = value;

			// Use untracked to initialize the signal
			this.state = untracked(() => {
				const newState = signal<string | null>(FormattingUtility.bytesAsFriendly((value as any) * Math.pow(1024, 2)));
				return newState;
			});

			// Clear any existing interval to avoid overlapping updates
			if (this.intervalId) {
				clearInterval(this.intervalId);
			}

			// Start the timer
			this.startTimer(value);
		}

		// Return the signal's current value
		return this.state();
	}

	ngOnDestroy(): void {
		// Clear the interval when the pipe is destroyed to prevent memory leaks
		if (this.intervalId) {
			clearInterval(this.intervalId);
		}
	}
}
